import { render, staticRenderFns } from "./PresentationViewer.vue?vue&type=template&id=c15ed3ec&scoped=true"
import script from "./PresentationViewer.vue?vue&type=script&lang=js"
export * from "./PresentationViewer.vue?vue&type=script&lang=js"
import style0 from "./PresentationViewer.vue?vue&type=style&index=0&id=c15ed3ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15ed3ec",
  null
  
)

export default component.exports